// import { call, put } from 'redux-saga/effects'
import FilesActions from '../Redux/FilesRedux'
import { baseFetchToken } from './BaseSaga'

import { getToken } from '../Services/GetToken'

export function * uploadFiles (api, action) {
  yield baseFetchToken(api.uploadFiles,
    action.data,
    getToken,
    FilesActions.filesUploadSuccess,
    FilesActions.filesUploadFailure)
}



// WEBPACK FOOTER //
// ./src/Sagas/FilesSagas.js